import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { getCountryList, getServiceOfferingsList } from "../../api";
import { FORM_FIELDS } from "../../constants";
import { CancelIcon, FormDropDown, FormDropDownCreatable } from "../core";
import {
  getTags,
  getTagsOnLoad,
  addNewServiceOfferings,
} from "./helper/inputTags";

export const ServiceOfferingTags = ({ tags, setTags, state }) => {
  const [selectedServiceOfferings, setSelectedServiceOfferings] = useState([]);
  const [selectedServiceCountries, setSelectedServiceCountries] = useState([]);
  const [tagError, setTagError] = useState(false);
  const [serviceofferingOptions, setServiceofferingOptions] = useState([]);

  useEffect(() => {
    if (Array.isArray(state)) {
      state?.forEach((data) => {
        const newTag = getTagsOnLoad(
          data?.servicesProvided,
          data?.serviceCountries
        );
        setTags((tags) => [...tags, newTag]);
      });
    } else if (state !== "") {
      state?.servicesProvided?.forEach((data, index) => {
        const newTag = getTagsOnLoad(data, state.serviceCountries[index]);
        setTags((tags) => [...tags, newTag]);
      });
    }

    setSelectedServiceOfferings([]);
    setSelectedServiceCountries([]);
  }, [setTags, state]);

  useEffect(() => {
    const getServiceOfferings = async () => {
      const resp = await getServiceOfferingsList({
        operation: "fetchServiceOffering",
      });
      const serviceOfferings = resp?.map((data) => data.name);
      setServiceofferingOptions(serviceOfferings);
    };
    getServiceOfferings();
  }, []);

  const handleRemoveTag = (e, tagToRemove) => {
    e.preventDefault();
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const handleAddTag = async (e) => {
    e.preventDefault();
    if (
      (selectedServiceOfferings.label || selectedServiceOfferings.length > 0) &&
      selectedServiceCountries.length > 0
    ) {
      const newService = await addNewServiceOfferings(selectedServiceOfferings);
      if (newService) {
        setServiceofferingOptions((prevOptions) => [
          ...prevOptions,
          newService.name,
        ]);
      }
      setTagError(false);
      const tagsData = getTags(
        selectedServiceOfferings,
        selectedServiceCountries
      );
      if (tagsData.length > 0) {
        setSelectedServiceOfferings([]);
        setSelectedServiceCountries([]);
        setTags([...tags, tagsData]);
      } else {
        setTagError(true);
      }
    } else {
      setTagError(true);
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 px-2 py-2 shadow-xl">
        <FormDropDownCreatable
          labelName={FORM_FIELDS.SERVICES_PROVIDED}
          options={serviceofferingOptions}
          onChange={(selected) => setSelectedServiceOfferings(selected)}
          value={selectedServiceOfferings}
          required={true}
        />
        <FormDropDown
          isMulti={true}
          labelName={FORM_FIELDS.SERVICE_COUNTRIES}
          isClearable
          options={getCountryList()}
          onChange={(selected) => setSelectedServiceCountries(selected)}
          value={selectedServiceCountries}
        />
        {tagError && (
          <span className="text-red-500 text-sm">
            Please select options to add
          </span>
        )}
        <div className="flex justify-end">
          <button
            type="button"
            className="bg-teal-600 text-white text-center text-lg px-3 font-normal mr-auto ml-auto"
            onClick={handleAddTag}
          >
            {FORM_FIELDS.BTN_ADD}
          </button>
        </div>
      </div>
      <div
        className="grid grid-cols-1 px-2 rounded-md"
        data-testid="tags-container"
      >
        {tags.length > 0 && (
          <div className="inline-block gap-2 mt-1">
            {tags.map((tag, index) => (
              <span
                key={index + 1}
                className="inline-flex items-center rounded-xl bg-gray-200 px-1 mx-1 my-1 text-md font-medium ring-1 ring-inset ring-gray-500/10 h-fit space-x-2"
              >
                <span>{tag}</span>
                <button
                  type="button"
                  onClick={(e) => handleRemoveTag(e, tag)}
                  className="text-black text-xl font-bold"
                  data-testid="remove"
                >
                  <CancelIcon />
                </button>
              </span>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

ServiceOfferingTags.propTypes = {
  tags: PropTypes.array.isRequired,
  setTags: PropTypes.func.isRequired,
  state: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
